import React from "react";
import { profile, links, about } from "../content";
import { Github, Linkedin, LeetCode, Youtube, Mail } from "./Icons";

const socials = [
  { label: "LinkedIn", href: links.linkedin, Icon: Linkedin },
  { label: "GitHub", href: links.github, Icon: Github },
  { label: "LeetCode", href: links.leetcode, Icon: LeetCode },
  { label: "YouTube", href: links.youtube, Icon: Youtube },
  { label: "Email", href: links.email, Icon: Mail },
];

const Footer = () => (
  <footer className="footer">
    <div className="shell">
      <div className="footer-top">
        <div>
          <h2 className="footer-cta">{about.closing}</h2>
          <p className="footer-note">
            Always up for a conversation about backend systems, RAG, or
            building products on the side.
          </p>
        </div>

        <div className="footer-contact">
          <a className="footer-mail" href={links.email}>
            {profile.email}
          </a>
          <div className="social-row" style={{ marginTop: 6 }}>
            {socials.map(({ label, href, Icon }) => (
              <a
                key={label}
                className="social-link"
                href={href}
                aria-label={label}
                target={href.startsWith("mailto") ? undefined : "_blank"}
                rel="noreferrer"
              >
                <Icon />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span className="footer-copy">
          © {new Date().getFullYear()} {profile.name}
        </span>
        <span className="footer-copy">{profile.location}</span>
      </div>
    </div>
  </footer>
);

export default Footer;
